import React from 'react'
import Link from 'gatsby-link'

const NavLink = (props) => (
  <div style={{
    listStyle: 'none',
    display: 'inline-block',
  }}>
    <li><Link style={{
      color: '#cfcfcf',
      textDecoration: 'none',
      textTransform: 'uppercase',
      margin: '15',
      fontWeight: '100',
      letterSpacing: '1px',
    }} to={props.url}>{props.text}</Link></li>
  </div>
)

export default NavLink



// WEBPACK FOOTER //
// ./src/components/navlink.js